/**
 * schemaAttributes selectors
 */
import { createSelectorCreator, defaultMemoize } from 'reselect';
import isEqual from 'lodash.isequal';

interface State {
    schemaAttributes: {
        [string]: {
            name: string
        }
    };
}

interface Props {
    schemaAttributeId?: number | string;
}

const createDeepEqualSelector = createSelectorCreator(defaultMemoize, isEqual);

const selectSchemaAttributes = (state: State) => state.schemaAttributes;
const selectSchemaAttributeId = (state: State, props: Props) =>
    props.schemaAttributeId && `${props.schemaAttributeId}`;

const selectSchemaAttributesArray = createDeepEqualSelector(
    selectSchemaAttributes,
    schemaAttributesState => Object.values(schemaAttributesState)
);

const selectSchemaAttribute = createDeepEqualSelector(
    selectSchemaAttributes,
    selectSchemaAttributeId,
    (schemaAttributesState, schemaAttributeId) =>
        schemaAttributeId && schemaAttributesState[schemaAttributeId]
);

const makeSelectSchemaAttributeValue = (field: string) =>
    createDeepEqualSelector(
        selectSchemaAttribute,
        schemaAttributeState =>
            schemaAttributeState && schemaAttributeState[field]
    );

export {
    selectSchemaAttributes,
    selectSchemaAttributesArray,
    selectSchemaAttribute,
    makeSelectSchemaAttributeValue
};
